import script from "./ServiceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceInfo.vue?vue&type=script&setup=true&lang=js"

import "./ServiceInfo.vue?vue&type=style&index=0&id=3c5aa103&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5aa103"]])

export default __exports__